// Unsaved Manage Users edits, keyed by user id and kept apart from the loaded page of users, so
// changing page (which reloads `users`) doesn't throw them away. Each draft holds only the fields
// the card edits: permissions, isGlobalAdmin, notifyOnTwilioMessage, notifyOnMissedCall.

const grantedKeys = (perms) =>
  Object.keys(perms || {})
    .filter((k) => perms[k] === true)
    .sort()
    .join(",");

function matchesSaved(draft, saved) {
  return Object.keys(draft).every((field) =>
    field === "permissions"
      ? grantedKeys(draft.permissions) === grantedKeys(saved.permissions)
      : !!draft[field] === !!saved[field]
  );
}

// The loaded users with each one's unsaved edits laid over it.
export function withDrafts(users, drafts) {
  return users.map((u) => (drafts[u._id] ? { ...u, ...drafts[u._id] } : u));
}

// Record `changes` for `user`. When `saved` (the user as last loaded from the server) is given
// and the edits now match it again, the draft is dropped, so the card stops saying "unsaved".
export function editDraft(drafts, user, changes, saved) {
  const draft = { ...drafts[user._id], ...changes };
  if (saved && matchesSaved(draft, saved)) return clearDraft(drafts, user._id);
  return { ...drafts, [user._id]: draft };
}

export function clearDraft(drafts, userId) {
  if (!drafts[userId]) return drafts;
  const { [userId]: _dropped, ...rest } = drafts;
  return rest;
}

export function hasDraft(drafts, userId) {
  return !!drafts[userId];
}
